/* Shopify's existing checkbox handler refreshes the products and count.
   Show results must finish that flow by closing the drawer. Native GET remains
   the fallback when the legacy Ajax handler is unavailable. */
(() => {
  const panel = document.querySelector('#filter.dama-filters');
  const form = panel?.closest('form');
  if (!form) return;
  form.addEventListener('submit', event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const target = new URL(form.action, location.href);
    const params = new URLSearchParams(new FormData(form));
    const current = new URLSearchParams(location.search);
    const selected = [...params].filter(([key]) => key.startsWith('filter.'));
    const active = [...current].filter(([key]) => key.startsWith('filter.'));
    const canonical = pairs => JSON.stringify(pairs.sort((a,b) => (a[0]+a[1]).localeCompare(b[0]+b[1])));
    if (canonical(selected) !== canonical(active)) {
      new Set(current.keys()).forEach(key => {
        if (/^(?:utm_(?:source|medium|campaign|content|term|id|source_platform)|gclid|gbraid|wbraid|gad_source|gad_campaignid|fbclid|ttclid|oppref|preview_theme_id|preview_script_id)$/.test(key)) {
          params.delete(key);
          current.getAll(key).forEach(value => params.append(key, value));
        }
      });
      target.search = params.toString();
      location.assign(target.href);
      return;
    }
    panel.querySelector('[data-popup-close]')?.click();
    document.querySelector('[data-listing]')?.scrollIntoView({block:'start',behavior:'smooth'});
  }, true);
})();
